import { render, staticRenderFns } from "./DepartmentFunctionSelection.vue?vue&type=template&id=0a1c22e2&"
import script from "./DepartmentFunctionSelection.vue?vue&type=script&lang=js&"
export * from "./DepartmentFunctionSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports